import apiClient from "./apiClient";

export const getLolPregame = (params) => apiClient.get("/lol-pregame", { params });
